import { votingIds } from "@artists/challenges-testkit"
import { CardContent, CardSubTitle, CardTitle } from "@artists/uikit"
import { Link } from "@mui/material"
import type { ReactNode } from "react"
import { Trans } from "react-i18next"

import type { Entry } from "../../../api/hooks/challenge"
import { designerLink } from "../../../utils"
import { Favorite } from "../favorite"

interface Props {
	isChecked: boolean
	entry: Entry
	actionButton: ReactNode
	onPdpClick?: () => void
}

export const CardActions = ({ entry, actionButton, onPdpClick }: Props) => {
	const { entryTitle, user } = entry

	return (
		<>
			<CardContent>
				{actionButton}

				<CardTitle>
					<Link
						data-testid={votingIds.entryTitle}
						href={entry.pdpUrl}
						target='_blank'
						underline='hover'
						onClick={onPdpClick}
					>
						{entryTitle}
					</Link>
				</CardTitle>

				<CardSubTitle>
					<Trans
						ns='common'
						i18nKey='vote.by'
						values={{ artistName: user.userName }}
					>
						<Link
							data-testid={votingIds.artistName}
							color='inherit'
							target='_blank'
							href={designerLink(user.userName)}
							underline='hover'
						/>
					</Trans>
				</CardSubTitle>
			</CardContent>

			<Favorite entry={entry} sx={{ m: 1, mt: -1 }} />
		</>
	)
}
